import { api, getWithOptionalAuthorizationGeneric } from './api';
import { getToken } from './auth';
import { AxiosResponse } from 'axios';
import { decryptMessage } from '../utils/decrypt';
import { REGION_WISE_CONTENT_MANAGEMENT_BASE } from './apiConstant';

export type RegionResponse = {
  id: string;
  sectionName: string;
  fileName: string;
  fileUrl: string;
  mobileFileUrl: string;
  createdAt: string; // ISO date string
  description: string;
};

const regionWiseContentManagementApi = {

  getRegionWiseContentManagement: async (): Promise<RegionResponse> => {
    try {
      const regionResponse = await getWithOptionalAuthorizationGeneric<RegionResponse[]>(`${REGION_WISE_CONTENT_MANAGEMENT_BASE}`, false);
      return regionResponse;
    } catch (error) {
      console.error('Error fetching regionwise content management:', error);
      throw error;
    }
  }
};

export default regionWiseContentManagementApi;